import { Button,Input, Tabs, TabItem, ProgressBar } from 'components/atoms/index';
import { Icon } from 'icons';
import { vars } from 'style/theme.css'
import { useLocation, useNavigate } from 'react-router-dom';
import { getSlugPrefix } from '@/utils/slug';
import HomeworkTable from '@/components/organisms/Table/HomeworkTable';


// 학생 마이페이지 - 숙제 채점표
export default function StudentMyPageHomework() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const slugPrefix = getSlugPrefix(pathname);
    
    const tabItems: TabItem[] = [
        { id: `${slugPrefix}/mypage/info`, label: '기본정보',onClick: () => navigate(`${slugPrefix}/mypage/info`) },
        { id: `${slugPrefix}/mypage/homework`, label: '숙제 채점표',onClick: () => navigate(`${slugPrefix}/mypage/homework`) },
        { id: `${slugPrefix}/mypage/exam`, label: '시험 성적표',onClick: () => navigate(`${slugPrefix}/mypage/exam`) },
        { id: `${slugPrefix}/mypage/trophy_badge`, label: '트로피 및 뱃지',onClick: () => navigate(`${slugPrefix}/mypage/trophy_badge`) },
      ];

  return (
    <main className='flex flex-1 pt-8 w-full bg-white md:my-10 md:justify-center card md:py-5 md:bg-transparent'>
        <div className='flex-1 w-full'>
            <h1 className='px-5 pb-3 heading1'>마이페이지</h1>
            <Tabs tabs={tabItems} activeId={pathname}  />
            {/* 검색 */}
            <section className='px-5 lg:px-0'>
                <HomeworkTable type="student" />
            </section>
        </div>
    </main>
  )
}